/**
 * One-shot Web Speech API (Chrome: webkitSpeechRecognition), UK English.
 */
export function listenOnceEnGB(): Promise<string> {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      reject(new Error("NO_SPEECH_API"));
      return;
    }
    const Ctor = window.SpeechRecognition ?? window.webkitSpeechRecognition;
    if (!Ctor) {
      reject(new Error("NO_SPEECH_API"));
      return;
    }

    const r = new Ctor();
    r.lang = "en-GB";
    r.interimResults = false;
    r.continuous = false;
    let gotResult = false;

    r.onresult = (e: SpeechRecognitionEvent) => {
      gotResult = true;
      const t = e.results[0]?.[0]?.transcript?.trim() ?? "";
      try {
        r.stop();
      } catch {
        /* ignore */
      }
      resolve(t);
    };

    r.onerror = (e: SpeechRecognitionErrorEvent) => {
      if (gotResult) return;
      try {
        r.stop();
      } catch {
        /* ignore */
      }
      reject(new Error(e.error || "speech_error"));
    };

    r.onend = () => {
      if (!gotResult) {
        reject(new Error("NO_SPEECH_RESULT"));
      }
    };

    try {
      r.start();
    } catch (err) {
      reject(err instanceof Error ? err : new Error("sr_start_failed"));
    }
  });
}
